export const RESET_PASSWORD_PURPOSE = Object.freeze({
    FIRST_TIME_LOGIN: 'first_time_login',
    FORGOT_PASSWORD: 'forgot_password'
  })
  